import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Select from '../../../components/select';

/* import fetch function */
import { SettingSendMessageTime, FetchMessageSetting } from "../../../services/message";

const SetSendMessageTime = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    
    useEffect(() => {
        FetchMessageSetting().then(response => {
            setSource(response);
        })
    }, []);

  

    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        delete error[name];

        _source[name] = value;
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {     
            SettingSendMessageTime({ id: source.messageTime }).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['messageTime'];
        const _errors = {};

        checkLists.map( list => 
            (!source[list]) && ( _errors[list] = true)
        );
        
        if (Object.keys(_errors).length) 
            {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Setting</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label lg-label'>Sending message frequency</div>
                        <span className='semicolon'>：</span>
                        <Select name='messageTime' select_all={ false } shadow={ false } required={ error.messageTime } _default={ source.codeId } changHandle={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default SetSendMessageTime;